/* EDELVETICA – Navigationspfeile für die Produktgalerie (Desktop)
   Ergänzt die horizontale Bildergalerie (.responsive-gallery-container)
   um einen Pfeil links und rechts. Auf Mobile bleibt alles wie bisher,
   dort übernimmt weiterhin das Wischen bzw. das bestehende Karussell. */
(function () {
  var CSS =
    '.gal-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:20;' +
    'width:44px;height:44px;padding:0;border:0;border-radius:50%;background:#960000;color:#fff;' +
    'display:flex;align-items:center;justify-content:center;cursor:pointer;' +
    'box-shadow:0 2px 10px rgba(0,0,0,.22);transition:opacity .2s ease,background .2s ease}' +
    '.gal-arrow:hover{background:#7d0000}' +
    '.gal-arrow:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
    '.gal-arrow--prev{left:10px}' +
    '.gal-arrow--next{right:10px}' +
    '.gal-arrow[disabled]{opacity:0;pointer-events:none}' +
    '.gal-arrow svg{width:16px;height:16px;display:block}' +
    '@media (max-width:767px){.gal-arrow{display:none}}';

  var SVG_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

  function injectCss() {
    if (document.getElementById('gal-arrow-css')) return;
    var st = document.createElement('style');
    st.id = 'gal-arrow-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function setup(container) {
    if (!container || container.querySelector('.gal-arrow')) return;
    var wrap = container.querySelector('.responsive-gallery-wrapper');
    if (!wrap) return;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'gal-arrow gal-arrow--prev';
    prev.setAttribute('aria-label', 'Vorheriges Bild');
    prev.innerHTML = SVG_PREV;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'gal-arrow gal-arrow--next';
    next.setAttribute('aria-label', 'Nächstes Bild');
    next.innerHTML = SVG_NEXT;

    function step() {
      var item = wrap.querySelector('.responsive-gallery-item');
      if (!item) return Math.round(wrap.clientWidth * 0.8);
      var gap = parseInt(getComputedStyle(wrap).columnGap, 10) || 0;
      return Math.round(item.getBoundingClientRect().width) + gap;
    }

    function update() {
      var max = wrap.scrollWidth - wrap.clientWidth - 2;
      prev.disabled = wrap.scrollLeft <= 2;
      next.disabled = wrap.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      wrap.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      wrap.scrollBy({ left: step(), behavior: 'smooth' });
    });
    wrap.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    container.appendChild(prev);
    container.appendChild(next);
    update();
  }

  function init() {
    injectCss();
    var list = document.querySelectorAll('.responsive-gallery-container');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Galerie wird beim Variantenwechsel neu aufgebaut – dann erneut ergänzen
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { init(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
